import { createFileRoute } from "@tanstack/react-router";
import { GlobalShell } from "~/components/GlobalShell";
import Link from "~/components/Link";
import { Dropdown } from "~/components/Dropdown";

export const Route = createFileRoute("/reset-password-failure")({
  component: ResetPasswordFailurePage,
});

function ResetPasswordFailurePage() {
  return (
    <GlobalShell>
      <div className="flex  items-center justify-center">
        <div className="card bg-base-100 w-96 shadow-xl max-w-[90vw]">
          <div className="card-body">
            <h1 className="card-title">Reset Password Failed</h1>
            <p>
              It looks like your password reset link is invalid or has expired.
            </p>
            <p>
              Please try resetting your password again or contact us if you have
              any questions.
            </p>
            <div className="mt-4 text-sm opacity-80 flex flex-row gap-2 justify-center w-full">
              <Link href="/forgot-password" className="link link-hover">
                Forgot Password
              </Link>
              <div>|</div>
              <Dropdown
                placement="top"
                btn={<a className="link link-hover">Need help?</a>}
              >
                <div className="max-w-[30ch]">
                  The best way to reach the SimpleIEP team is by email at{" "}
                  <a
                    className="link link-hover underline"
                    href="mailto:hello@simple-iep.com"
                  >
                    hello@simple-iep.com
                  </a>
                  .
                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </GlobalShell>
  );
}
